import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c79170a0")
const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login_image" }, null, -1)
const _hoisted_3 = { class: "login_form" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = {
  class: "p-col-12",
  style: {"text-align":"left"}
}
const _hoisted_8 = { class: "login_label" }
const _hoisted_9 = { class: "login_input" }
const _hoisted_10 = {
  class: "p-col-12",
  style: {"text-align":"left"}
}
const _hoisted_11 = { class: "login_label" }
const _hoisted_12 = { class: "login_input" }
const _hoisted_13 = { class: "p-col-12 login_form__actions" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_VField = _resolveComponent("VField")!
  const _component_VI18nError = _resolveComponent("VI18nError")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VForm = _resolveComponent("VForm")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("img", {
          alt: "Logo",
          src: '/assets/layout/images/' + _ctx.logo,
          width: "400"
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_VForm, {
        onSubmit: _ctx.save,
        as: "form"
      }, {
        default: _withCtx(({ isSubmitting, meta: { valid } }) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("label", _hoisted_8, null, 512), [
                [_directive_t, 'reset_password.new_password']
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_VField, {
                  name: "password",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.password = $event)),
                  rules: "required"
                }, {
                  default: _withCtx(({ field, meta: {dirty, valid} }) => [
                    _createVNode(_component_InputText, _mergeProps({ autocomplete: "new-password" }, field, {
                      disabled: isSubmitting,
                      class: {'p-invalid': dirty && !valid},
                      type: "password",
                      placeholder: "New password"
                    }), null, 16, ["disabled", "class"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"]),
                _createVNode(_component_VI18nError, { name: "password" })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("label", _hoisted_11, null, 512), [
                [_directive_t, 'reset_password.confirm_password']
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_VField, {
                  name: "confirm_password",
                  modelValue: _ctx.confirm_password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm_password = $event)),
                  rules: "required"
                }, {
                  default: _withCtx(({ field, meta: {dirty, valid} }) => [
                    _createVNode(_component_InputText, _mergeProps({ autocomplete: "new-password" }, field, {
                      disabled: isSubmitting,
                      class: {'p-invalid': dirty && !valid},
                      type: "password",
                      placeholder: "Confirm password"
                    }), null, 16, ["disabled", "class"])
                  ]),
                  _: 2
                }, 1032, ["modelValue"]),
                _createVNode(_component_VI18nError, { name: "confirm_password" })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Button, {
                label: _ctx.$t('save'),
                type: "submit",
                disabled: !valid || isSubmitting
              }, null, 8, ["label", "disabled"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}